<div class="file-upload-container">
  <p-toast key="mensajesDeValidacion" aria-keyshortcuts="on"></p-toast>
  <!-- Zona de drop para archivos -->
  <button
    type="button"
    class="drop-zone"
    [class.drag-over]="isDragOver"
    [class.disabled]="disabled"
    [disabled]="disabled"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="openFileSelector()"
    [attr.aria-label]="placeholder"
  >
    <div class="drop-zone-content">
      <!-- Ícono de cursor/mouse -->
      <div class="drop-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
        >
          <path
            d="M19 20.5835V33.2502"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6.33322 23.5903C5.15687 22.3884 4.26945 20.9346 3.73819 19.3389C3.20693 17.7433 3.04575 16.0476 3.26687 14.3805C3.48799 12.7133 4.08561 11.1183 5.01445 9.71635C5.9433 8.31437 7.17901 7.14214 8.628 6.28846C10.077 5.43479 11.7012 4.92205 13.3777 4.78909C15.0542 4.65613 16.739 4.90643 18.3044 5.52104C19.8699 6.13564 21.2749 7.09843 22.4131 8.33648C23.5514 9.57453 24.3929 11.0554 24.8741 12.6668H27.7082C29.2369 12.6667 30.7252 13.1582 31.9531 14.0688C33.181 14.9794 34.0835 16.2608 34.5273 17.7237C34.971 19.1866 34.9325 20.7534 34.4173 22.1928C33.9022 23.6321 32.9378 24.8676 31.6666 25.7167"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M12.6667 26.9168L19.0001 20.5835L25.3334 26.9168"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <!-- Texto principal -->
      <div class="drop-text-primary">{{ placeholder }}</div>
      <!-- Texto secundario -->
      <div class="drop-text-secondary">{{ subPlaceholder }}</div>
      <!-- Texto terciario -->
      <div class="drop-text-tertiary">{{ tertiaryPlaceholder }}</div>
      <!-- Texto cuaternario -->
      <div class="drop-text-quaternary">Haz click aquí</div>
    </div>
  </button>

  <!-- Input de archivo oculto -->
  <input
    #fileInput
    type="file"
    [accept]="acceptedTypes"
    [multiple]="multiple"
    [disabled]="disabled"
    (change)="onFileInputChange($event)"
    style="display: none"
  />

  <!-- Lista de archivos seleccionados -->
  <div class="flex justify-content-end mt-5 cantidad-archivos" *ngIf="files.length">
    {{ files.length }} / {{ maxFiles }} archivos cargados
  </div>
  <div class="files-list" *ngIf="files.length > 0">
    <div *ngFor="let fileItem of files; trackBy: trackByFile">
      <div class="file-item" [class.selected]="fileItem.seleccionado">
        <i
          *ngIf="fileItem.seleccionado && !showSelectCheckbox"
          class="pi pi-spin pi-spinner"
          style="font-size: 1.5rem"
        ></i>

        <!-- Ícono del archivo -->
        <div class="file-icon">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 2V8H20"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <!-- Información del archivo -->
        <div class="file-info">
          <div class="file-name">{{ fileItem.name }}</div>
          <div class="file-size">{{ formatFileSize(fileItem.file.size) }}</div>
        </div>

        <!-- Estado del archivo -->
        <div class="file-status">
          <!-- Progreso de carga -->
          <div class="progress-container" *ngIf="!fileItem.isComplete && !fileItem.hasError">
            <div class="progress-bar">
              <div class="progress-fill" [style.width.%]="porcentajeSubida"></div>
            </div>
            <div class="progress-text">{{ porcentajeSubida | number : '1.0-0' }}%</div>
          </div>

          <!-- Archivo completado -->
          <div class="completion-indicator" *ngIf="fileItem.isComplete && !fileItem.hasError">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <!-- Error -->

          <div class="error-indicator" *ngIf="fileItem.hasError">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
              <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2" />
              <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2" />
            </svg>
          </div>
        </div>

        <button
          (click)="verLote(fileItem.loteId ?? 0)"
          *ngIf="!disabled && !fileItem.hasError"
          class="ver-detalles"
          type="button"
          title="Ver archivo"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <!-- Botón para eliminar archivo -->
        <button
          *ngIf="!disabled"
          class="remove-button"
          type="button"
          (click)="removeFile(fileItem)"
          [disabled]="disabled"
          title="Eliminar archivo"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M10 11V17"
              stroke="#A70000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14 11V17"
              stroke="#A70000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6"
              stroke="#A70000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M3 6H21"
              stroke="#A70000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
              stroke="#A70000"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="projected-actions" *ngIf="files.length > 0">
    <ng-content></ng-content>
    <!-- Todo lo que pongas entre las etiquetas aparece aquí -->
  </div>
</div>
